import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/login/src/components/LanguageCombobox/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentWrapper","StyledPage"] */ "/app/onlyoffice/src/client/packages/login/src/components/Layout.styled.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/onlyoffice/src/client/packages/login/src/components/SimpleNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Scrollbar"] */ "/app/onlyoffice/src/client/packages/shared/components/scrollbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ar-SA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/az.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/bg.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/cs.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de-AT.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de-CH.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/de.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/el-GR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/en-GB.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/en-US.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/es-MX.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/es.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/fi.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/fr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/hy-AM.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/it.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ja-JP.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ko-KR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/lo-LA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/lv.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/nl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pt-BR.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/pt.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ro.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/ru.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/si.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sk.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sl.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sq-AL.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/sr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/tr.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/uk-UA.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/vi.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/flags/zh-CN.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/logo/favicon.ico");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.apple.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.facebook.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.google.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.linkedin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.microsoft.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.twitter.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.weixin.react.svg");
;
import(/* webpackMode: "eager" */ "/app/onlyoffice/src/client/public/images/share.zoom.react.svg");
